import { render, staticRenderFns } from "./certificateDetails.vue?vue&type=template&id=ec3db8d8&scoped=true&"
import script from "./certificateDetails.vue?vue&type=script&lang=js&"
export * from "./certificateDetails.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetails.vue?vue&type=style&index=0&id=ec3db8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3db8d8",
  null
  
)

export default component.exports